import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { marker as TRANSLATE } from '@biesbjerg/ngx-translate-extract-marker';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, MessageService } from 'primeng/api';
import * as fromStore from '../../store';
import * as fromFeature from '../../my-features';
import { Store } from '@ngrx/store';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
import { updateInfoType, GateWaySnmpProfile, CheckDiscoveryJobBySec } from '../../shareModel';
import { DevicesInfoData } from '../../models/devices';
import { UpdateInfoModel } from '../../my-features/updateInfo/update-info.model';
import { PlanSettingParams } from 'src/app/my-features/plan/plan-setting.model';
import { User } from '../../models/user';
import { DialogComponent } from 'src/app/dialog/dialog.component';

@Component({
  standalone: false,
  selector: 'app-connection-device',
  templateUrl: './connection-device.component.html',
  styleUrls: ['./connection-device.component.css'],
  providers: [MessageService]
})
export class ConnectionDeviceComponent implements OnInit {
  @Input() editProAuth!: boolean;
  @Input() IsSuperAdmin!: boolean;
  private componentDestroyed = new Subject();
  UpdateInfoParam = {} as UpdateInfoModel;
  connectionDevice_cols: any[] = [
    { field: 'company', header: TRANSLATE('Company'), width: '250', class: 'col-nowrap', disabled: false },
    { field: 'gateName', header: TRANSLATE('Gateway Name'), width: '250', class: 'col-nowrap ellipsis', disabled: false },
    { field: 'device', header: TRANSLATE('Device Name'), width: '250', class: 'col-nowrap', disabled: false },
    { field: 'model', header: TRANSLATE('Model Name'), width: '200', class: 'col-nowrap ellipsis', disabled: false },
    { field: 'brand', header: TRANSLATE('Brand'), width: '150', class: 'col-nowrap ellipsis', disabled: false },
    { field: 'category', header: TRANSLATE('Category'), width: '150', class: 'col-nowrap ellipsis', disabled: false },
    { field: 'ipAddress', header: TRANSLATE('IP address'), width: '150', class: 'col-nowrap', disabled: false },
    { field: 'protocol', header: TRANSLATE('Network Protocol'), width: '150', class: 'col-nowrap ellipsis', disabled: false },
    { field: 'startConnectDate', header: TRANSLATE('Start connect date'), width: '180', class: 'col-nowrap', disabled: false },
  ];
  gatewayList = [];
  deviceList = [];
  connectionDevice = [];
  connectionDeviceDic = [];
  gatewayDic = [];
  rgionDic = [];
  gatewayDicByRegion = [];
  profileDicByRegion = [];
  profileDic = [];
  categoryDic = [];
  disableGateWayFlag = false;
  disableProfileFlag = false;
  displayDialog = false;
  displayConfirmDialog = false;
  selectedNode: any = null;
  dialogInput: {
    Id?: number;
    UpdateType: string;
    company?: string;
    gateway: string;
    ipAddress: string;
    SNMPProfile: string;
    deviceModel: string;
    device: string;
  };
  gatewayOptions: SelectItem[] = [
  ];
  dailogGatewayOptions: SelectItem[] = [
  ];
  profileOptions: SelectItem[] = [
  ];
  companyOptions: SelectItem[] = [
  ];
  tabIndex = 0;
  checkGatewayReuslt: boolean;
  ipAddressPattern = /((^|\.)((25[0-5])|(2[0-4]\d)|(1\d\d)|([1-9]?\d))){4}$/;
  selectedGateway:number = 0;
  isMsp:boolean = false;
  intervalId: any = null;
  checkDiscoveryExecutingFlag = false;
  ExecId:number = 0;
  params: {
    otp: string;
    RegionIds?: [];
  };
  discoveryList = [];
  disableGatewayDic = [];
  mspFilter : any;
  UserParam = {} as User;
  clickAddToCloud : boolean = false;
  @ViewChild(DialogComponent, { static: false }) childDialog: DialogComponent;
  constructor(private translateService: TranslateService,
    private store: Store<fromStore.State>,
    private messageService: MessageService) {
    
    // this.ngxService.start();

    combineLatest( this.store.select(fromStore.getRegions),this.store.select(fromStore.getMspMemberAuthority),this.store.select(fromStore.getMspRegionFilter))
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(([region, mspAuth, mspFilter]) => {
        if (region !== undefined && region.length > 0 && mspAuth !== undefined && mspAuth.length > 0 && mspFilter !== null && mspFilter.selectedId !== undefined) {
          this.isMsp = mspFilter.isMsp;
          this.mspFilter = mspFilter
          this.rgionDic = [];
          region.map(r => {
            this.rgionDic[r.Id] = r;
          })
          this.companyOptions = [];
          this.companyOptions.push({ label: 'Select Company', value: 0 });
          if (this.rgionDic.length > 0) {
            // NgRx 9 不可變性: 創建數組副本再排序，避免修改只讀數組
            [...mspAuth].sort((a, b) => {
              return a.RegionId - b.RegionId;
              }).map((m) => {
                if (this.rgionDic[m.RegionId] !== undefined && m.EditDevice === 1 && mspFilter.selectedId !== null && mspFilter.selectedId.length > 0 && mspFilter.selectedId.includes(m.RegionId)) {
                this.companyOptions.push({
                  label: this.rgionDic[m.RegionId].RegionName,
                  value: m.RegionId
                })
              }
            })
          }
        }
    });

    // Get Profile List
    this.store
      .select(fromStore.ReadProfileList)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        if (res !== undefined && res !== null) {
          if (!res.Loading && res.Loaded && res.entities.length > 0) {
            this.profileDic = [];
            this.profileOptions = [];
            this.profileDicByRegion = [];
            this.profileOptions.push({ label: TRANSLATE('Select SMNP Profile'), value: 0 });
            res.entities.map((c) => {
              this.profileDic[c.Id] = c;
              const optionItem = { label: c.Name, value: c.Id }
              this.profileOptions.push(optionItem)
              if (c.RegionId !== undefined) {
                if (this.profileDicByRegion[c.RegionId] === undefined) {
                  this.profileDicByRegion[c.RegionId] = [];
                  this.profileDicByRegion[c.RegionId].push({ label: ('Select SMNP Profile'), value: 0 })
                }
                this.profileDicByRegion[c.RegionId].push(optionItem)
              }
            })
          }
        }
      });

    // Get Category List
    this.store
      .select(fromStore.ReadCategoryList)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        if (res !== undefined && res !== null && res.length > 0) {
          this.categoryDic = [];
          // 創建數組副本以避免修改只讀的 store 數據 (NgRx 9 immutability)
          [...res].sort(function (a: any, b: any) {
            return a.Value - b.Value;
          }).map((c) => {
            this.categoryDic[c.Value] = c;
          })
        }
    });
    
    // Get Gateway List && Get Discovery Job List
    this.store
      combineLatest(this.store.select(fromStore.ReadGateWayList), this.store.select(fromStore.ReadDiscoveryInfoList))
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(([gateway, discoveryList]) => {
        if (!gateway.Loading && gateway.Loaded && !discoveryList.Loading && discoveryList.Loaded) {
          if (discoveryList.entities !== undefined && discoveryList.entities !== null) {
            const noDisableGateway = [];
            const disableGateway = [];
            this.discoveryList = [];
            if (discoveryList.entities.length > 0) {
              for (const i in discoveryList.entities) {
                const info = discoveryList.entities[i];
                if (info !== undefined && info.GatewayList.length > 0) {
                  // 有在運行中的Job,把其中的所有GateWay做成Dic
                  if (info.EnableRun) {
                    info.GatewayList.map(i => {
                      if (noDisableGateway[i] === undefined) {
                        noDisableGateway[i] = i;
                      }
                    })
                  }
                  // 沒在運行中的Job,把其中的所有GateWay做成Dic
                  if (!info.EnableRun) {
                    info.GatewayList.map(i => {
                      if (disableGateway[i] === undefined) {
                        disableGateway[i] = i;
                      }
                    })
                  }
                }
              }
              this.disableGatewayDic = [];
              if (disableGateway.length > 0) {
                // 代表這些gateway所屬的discovery都正在RunningJob
                disableGateway.forEach((d) => {
                  // 排除正在運作中的discovery的gateway
                  // 要做此處理是因為有可能一個DiscoveryJob綁了兩個GateWay但其中一個正在Running另一個沒有
                  // 會做此邏輯是因為DiscoveryList沒有一個欄位可以直接判斷Gateway是否正在被拿來運行中
                  if (!noDisableGateway[d]) {
                    // 重新跑一次dailogGatewayOptions,將被運作中或是offline的Gateway壓成disable
                    this.disableGatewayDic[d] = d;
                  }
                })
              }
              // this.discoveryList = discoveryList.entities;
            }
          }
          if (gateway.entities !== undefined && gateway.entities !== null && Array.isArray(gateway.entities) && gateway.entities.length > 0) {
            this.gatewayDic = [];
            this.gatewayDicByRegion = [];
            this.gatewayOptions = [];
            this.dailogGatewayOptions = [];
            this.gatewayList = gateway.entities;
            const gatewayListIds = []
            this.gatewayOptions.push({ label: TRANSLATE('Select Gateway'), value: 0 });
            this.dailogGatewayOptions.push({ label: TRANSLATE('Select Gateway'), value: 0 });
            gateway.entities.forEach((g) => {
              this.gatewayDic[g.Id] = g;
              const optionItem = { label: g.Name, value: g.Id, disabled: false }
              if (g.Status === 1) { // Offline
                optionItem.disabled = true;
              }
              this.gatewayOptions.push({ label: g.Name, value: g.Id });
              if ( this.disableGatewayDic.length != 0 && this.disableGatewayDic[g.Id] !== undefined) {
                optionItem.disabled = true;
              }
              this.dailogGatewayOptions.push(optionItem);
              
              if (g.RegionId !== undefined) {
                if (this.gatewayDicByRegion[g.RegionId] === undefined) {
                  this.gatewayDicByRegion[g.RegionId] = [];
                  this.gatewayDicByRegion[g.RegionId].push({ label: TRANSLATE('Select Gateway'), value: 0 })
                }
                this.gatewayDicByRegion[g.RegionId].push(optionItem)
              }
              gatewayListIds.push(g.Id);
            })
            this.reloadDeviceList();
          }
        }
    });
    
    // Get GateWay Device List
    this.store
      .select(fromStore.ReadGateWayDeviceList)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        this.deviceList = [];
        this.connectionDeviceDic = [];
        if (!res.Loading && res.Loaded) {
          if (res.entities !== undefined && res.entities.length > 0) {
            if (!this.isMsp) {
              this.connectionDevice_cols = this.connectionDevice_cols.filter(col => !(col.field === 'company'));
            }
            res.entities.map((c => {
              const item = {
                GatewayId: c.GatewayId,
                GatewayName: c.GatewayName,
                DeviceList: []
              }
              if (c.DeviceList !== undefined && c.DeviceList.length > 0) {
                c.DeviceList.forEach((d) =>{
                  let company = null;
                  if (this.isMsp && this.gatewayDic[c.GatewayId] !== undefined && this.gatewayDic[c.GatewayId].RegionId !== undefined) {
                    if (this.rgionDic[this.gatewayDic[c.GatewayId].RegionId] !== undefined && this.rgionDic[this.gatewayDic[c.GatewayId].RegionId].RegionName !== undefined) {
                      company = this.rgionDic[this.gatewayDic[c.GatewayId].RegionId].RegionName;
                    }
                  }
                  const deviceInfo = {
                    company: company,
                    dcode: d.dcode,
                    ipAddress: d.IP,
                    SN: d.SN,
                    gatewayId: c.GatewayId,
                    gateName: c.GatewayName,
                    device: d.DeviceName,
                    model: d.Model,
                    brand: d.Brand,
                    category: this.categoryDic[d.Category] !== undefined ? this.categoryDic[d.Category].Category : '',
                    profileId: d.ProfileId,
                    protocol: this.profileDic[d.ProfileId] !== undefined ? GateWaySnmpProfile[this.profileDic[d.ProfileId].ProtocolType] !== undefined ? GateWaySnmpProfile[this.profileDic[d.ProfileId].ProtocolType] : '' : '',
                    startConnectDate: d.CreateTime !== undefined && d.CreateTime !== null ? moment(Number(d.CreateTime) * 1000).format('YYYY/MM/DD') : '',
                  }
                  item.DeviceList.push(deviceInfo)
                  this.deviceList.push(deviceInfo);
                })
              }
              this.connectionDeviceDic[c.GatewayId] = item;
            }))
          } 
          this.dispatchGatewayFilter();
        }
    });

    // Get Execute Discovery Response
    this.store
      .select(fromStore.ExecuteDiscovery)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        if (res !== null && res !== undefined && res !== '') {
          // console.log('ReadDiscoveryExecutingResultForOneTime: ' + res);
          this.ExecId = res.Id
          const param = {
            otp: '',
            ExecId: res.Id
          }
          this.store.dispatch(new fromFeature.ReadDiscoveryExecutingResultForOneTime(param));
        }
    });

    // Get Discovery Executing Result for One Time
    this.store
      .select(fromStore.ReadDiscoveryResultForOneTimeReducer)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        if (res !== undefined) {
          if (res.Status === 0) {
            this.checkDiscoveryExecutingFlag = true
            this.startInterval();
          } else {
            this.stopInterval();
            this.showCheckGatewayResult(res)
          }
        }
      });

    // Update Info
    this.store.select(fromStore.getUpdateInfoState).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (!res.isLoading && res.isLoaded) {
        if (res.type === updateInfoType.AddDeviceToCloud || res.type === updateInfoType.EditDeviceInfo || res.type === updateInfoType.DeleteDeviceSettingList) {
          this.messageService.clear();
          if (res.isSaved) {
            this.reloadDeviceList();
            if (res.type === updateInfoType.AddDeviceToCloud || res.type === updateInfoType.DeleteDeviceSettingList) {
              this.selectedNode = null;
              if (res.msg.body !== undefined && res.msg.body == '') {
                if (res.type === updateInfoType.AddDeviceToCloud) {
                  this.messageService.add({ severity: 'success', summary: this.translateService.instant(TRANSLATE('Add Success')) });
                } else if (res.type === updateInfoType.DeleteDeviceSettingList) {
                  this.messageService.add({ severity: 'success', summary: this.translateService.instant(TRANSLATE('Delete Success')) });
                }
              } else {
                this.messageService.add({ severity: 'success', summary: this.translateService.instant(TRANSLATE(res.msg)) });
              }
              if (this.isMsp) {
                const UserParam = {regionIds: this.mspFilter.selectedId} as User;
                this.store.dispatch(new fromStore.GetDevicesStatusAction(UserParam));
                this.store.dispatch(new fromStore.GetDeviceInfoAction({regionIds: this.mspFilter.selectedId}));
              } else {
                this.store.dispatch(new fromFeature.GetPlanSettings());
                this.store.dispatch(new fromStore.GetDevicesStatusAction());
                this.store.dispatch(new fromStore.GetDeviceInfoAction());
              }
            } else {
              this.messageService.add({ severity: 'success', summary: this.translateService.instant(TRANSLATE('success')) });
            }
          } else {
            if (res.type === updateInfoType.AddDeviceToCloud) {
              this.messageService.add({ severity: 'error', summary: this.translateService.instant(TRANSLATE(res.msg)) });
            } else {
              this.messageService.add({ severity: 'error', summary: this.translateService.instant(TRANSLATE('Failed')) });
            }
          }
          this.resetUpdateInfoState();
        }
      }
    })

    // Get Plan Setting Info
    this.store.select(fromStore.getPlanSetting).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (!res.Loading && res.Loaded) {
        if (this.clickAddToCloud && !this.isMsp) {
          let purchasingPlanList = Object.values(res.entities).filter((i) => i.Status !== 2); // no expired.
          purchasingPlanList = purchasingPlanList.map((item) => {
            return { ...item, expirationDate: (item.RemainDay > 0) ? new Date().setDate(new Date().getDate() + item.RemainDay) : 'Expired' };
          });
          const usingPlan = Object.values(purchasingPlanList).find((i) => i.Status === 1);
          let tab = 2;
          if (usingPlan) {
            const dcode_list = [...(Array.isArray(usingPlan.UsingDevices) ? usingPlan.UsingDevices : [])];
            if (this.deviceList && this.deviceList.length > 0) {
              this.deviceList.forEach(i => {
                if (i.device == this.dialogInput.device) {
                  dcode_list.push(Number(i.dcode));
                }
              });
            }
            const params: PlanSettingParams = {
              PlanInfoId: parseInt(usingPlan.Id, 10),
              dcodes: dcode_list // convert into number.
            };
            if (params.dcodes.length > usingPlan.NodeTotal) {
              tab = 1;
              this.childDialog.addDeviceToCloudRedirect(null , tab);
            } else {
              tab = 0;
              this.childDialog.addDeviceToCloudRedirect(params , tab);
            }
          } else {
            this.childDialog.addDeviceToCloudRedirect(null , tab);
          }
          this.clickAddToCloud = false;
        }
      }
    });
  }

  ngOnInit() {
    this.initDialogInput();
    // this.ngxService.stop();
  }

  initDialogInput() {
    this.dialogInput = {
      UpdateType: 'Add Device',
      company: '',
      gateway: '',
      ipAddress: '',
      SNMPProfile: '',
      deviceModel: '',
      device: ''
    };
    this.tabIndex = 0;
  }

  showDialog () {
    this.initDialogInput();
    this.displayDialog = true;
    this.dailogFilter();
  }

  showEditDialog () {
    this.displayDialog = true;
    this.tabIndex = 2;
    this.dialogInput = {
      Id: this.selectedNode.Id,
      UpdateType: 'Edit Device',
      company: this.selectedNode.company,
      gateway: this.selectedNode.gateway,
      ipAddress: this.selectedNode.ipAddress,
      SNMPProfile: this.selectedNode.SNMPProfile,
      deviceModel: this.selectedNode.model,
      device: this.selectedNode.device,
    };
  }

  showConfirmDialog() {
    this.displayConfirmDialog = true;
  }

  checkGateway() {
    this.tabIndex = 1;
    const gatewaylist = [];
    const profilelist = [];
    gatewaylist.push(this.dialogInput.gateway)
    profilelist.push(this.dialogInput.SNMPProfile)
    let param = {
      otp: '',
      Type: 1, //OneTime
      IP: this.dialogInput.ipAddress,
      GatewayList: gatewaylist,
      ProfileList: profilelist
    } as any;
    if (this.dialogInput.company !== undefined && this.dialogInput.company !== '' ) {
      param = {...param, RegionId: this.dialogInput.company}
    }
    this.store.dispatch(new fromFeature.ExecuteDiscovery(param));
  }

  showCheckGatewayResult(item) {
    this.checkGatewayReuslt = true;
    if (item.Status === 1) {
      if (item.SN !== undefined) {
        this.tabIndex = 2;
        this.dialogInput = {
          Id: item.Id,
          UpdateType: 'Add Device',
          company: this.dialogInput.company,
          gateway: this.dialogInput.gateway,
          ipAddress: item.IP,
          SNMPProfile: this.dialogInput.SNMPProfile,
          deviceModel: item.Model,
          device: '',
        };
      } else {
        this.tabIndex = 3;
      }
    } else if (item.Status === 3) {
      this.tabIndex = 5;
    } else {
      this.tabIndex = 4;
    }
  }

  addDevice() {
    const addDeviceParam = {
      otp: '',
      DeviceList:[{
        Id: this.dialogInput.Id,
        DeviceName: this.dialogInput.device,
      }]
    }
    if (!this.isMsp) {
      this.clickAddToCloud = true;
    }
    this.displayDialog = false;
    this.store.dispatch(new fromFeature.AddDeviceToCloud(addDeviceParam));
    this.selectedNode = null;
  }

  saveDevice() {
    this.displayDialog = false;
    const data: DevicesInfoData = {
      dcode: this.selectedNode.dcode,
      deviceName: this.dialogInput.device,
    };
    this.store.dispatch(new fromStore.UpdateDeviceInfoAction(data));
    this.selectedNode = null;
  }

  deleteDevice() {
    this.displayConfirmDialog = false;
    this.store.dispatch(new fromFeature.GetDeleteDeviceSettingList({ dcode: this.selectedNode.dcode }));
  }

  dailogFilter(change : boolean = null) {
    if (!this.isMsp) {
      this.disableGateWayFlag = false;
      this.disableProfileFlag = false;
    } else {
      this.dailogGatewayOptions = [];
      this.profileOptions = [];
      this.disableGateWayFlag = true;
      this.disableProfileFlag = true;
      if (this.gatewayDicByRegion !== undefined && this.gatewayDicByRegion[this.dialogInput.company] !== undefined) {
        this.dailogGatewayOptions = this.gatewayDicByRegion[this.dialogInput.company];
        this.disableGateWayFlag = false;
      }
      if (this.profileDicByRegion !== undefined && this.profileDicByRegion[this.dialogInput.company] !== undefined) {
        this.profileOptions = this.profileDicByRegion[this.dialogInput.company];
        this.disableProfileFlag = false;
      }
    }
  }

  dispatchGatewayFilter() {
    if (this.selectedGateway === 0) {
      if (this.deviceList !== undefined && this.deviceList.length > 0) {
        this.connectionDevice = this.deviceList;
      } else {
        this.connectionDevice = [];
      }
    } else {
      if (this.connectionDeviceDic !== undefined && this.connectionDeviceDic[this.selectedGateway] !== undefined) {
        this.connectionDevice = this.connectionDeviceDic[this.selectedGateway].DeviceList;
      } else {
        this.connectionDevice = [];
      }
    }
    // this.ngxService.stop();
  }

  reloadDeviceList() {
    let gatewayListIds = []
    if (this.gatewayList !== undefined && this.gatewayList.length > 0) {
      gatewayListIds = this.gatewayList.filter(s=>s.Id).map(s => s.Id);;
      const param = {
        otp: '',
        GatewayList: gatewayListIds
      }
      this.store.dispatch(new fromFeature.ReadGatewayDeviceList(param));
    }
  }

  startInterval() {
    if (!this.intervalId) {
      this.intervalId = setInterval(() => {
        if (this.checkDiscoveryExecutingFlag == true) {
          const param = {
            otp: '',
            ExecId: this.ExecId
          }
          this.store.dispatch(new fromFeature.ReadDiscoveryExecutingResultForOneTime(param));
        }
      }, CheckDiscoveryJobBySec * 1000);
      // console.log("計時器已啟動");
    }
  }

  stopInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.checkDiscoveryExecutingFlag == false
      this.intervalId = null;
      // console.log("計時器已停止");
    }
  }

  stopDiscoveryJob() {
    if (this.ExecId !== undefined && this.ExecId !== 0) {
      const param = {
        otp: '',
        Id: this.ExecId
      }
      this.store.dispatch(new fromFeature.StopExecutingDiscovery(param));
    }
  }

  ngOnDestroy(): void {
    this.stopInterval();
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromFeature.UpdateInfoSuccessAction({ ...this.UpdateInfoParam }));
  }
}
